import BaseApi from '@/api/base';
import { getImpersonationParams } from '@/util';

const getJobContacts = (jobId: string) => BaseApi.get(`buyer/job/${jobId}/contacts`, { params: getImpersonationParams() });

const getProgressPhases = (jobId: string) => BaseApi.get(`buyer/jobprogress/${jobId}`, { params: getImpersonationParams() }, false);

const getPostCloseData = (jobId: string, currentPhase: string) => BaseApi.get(`buyer/postclosehome/${jobId}/${currentPhase}`, { params: getImpersonationParams() });

const getSelectedPhase = (area: string, step: string) => BaseApi.get(`manageContent/${step}/${area}`, { params: getImpersonationParams() });

export {
  getJobContacts,
  getProgressPhases,
  getPostCloseData,
  getSelectedPhase
};
